import axios from 'axios'

// const api_endpoint = 'http://127.0.0.1:5001'
// const api_endpoint = 'https://staging.enterprise.api.docmasweetspot.ca'
const api_endpoint = 'https://fn6mi7qqjd.execute-api.us-east-2.amazonaws.com/dev'
// const api_endpoint = 'https://d6itaje8h6.execute-api.us-east-2.amazonaws.com/prod'

function fetch_report_data(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/fetch_report_data';
    return axios_post_call(api_url, payload, token);
}

function fetch_report_locations(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/fetch_report_locations';
    return axios_post_call(api_url, payload, token);
}

function create_report_folder(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/create_report_folder';
    return axios_post_call(api_url, payload, token);
}

function get_reports(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/get_reports';
    return axios_post_call(api_url, payload, token);
}

function publish_report(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/publish_report';
    return axios_post_call(api_url, payload, token);
}

function update_report(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/update_report';
    return axios_post_call(api_url, payload, token);
}

function delete_report(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/delete_report';
    return axios_post_call(api_url, payload, token);
}

function move_reports(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/move_reports';
    return axios_post_call(api_url, payload, token);
}

function add_component(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/add_component';
    return axios_post_call(api_url, payload, token);
}

function edit_component(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/edit_component';
    return axios_post_call(api_url, payload, token);
}

function update_audience(token, payload){
    return axios_post_call(api_endpoint + '/sweetspot/reporting/update_audience', payload, token);
}

function delete_report_component(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/delete_component';
    return axios_post_call(api_url, payload, token);
}

function fetch_component_options(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/fetch_component_options';
    return axios_post_call(api_url, payload, token);
}

function save_report_plan(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/save_report_plan';
    return axios_post_call(api_url, payload, token);
}

function calculate_omni_channel(token, payload){
    let api_url = api_endpoint + '/sweetspot/reporting/calculate_omni_channel';
    return axios_post_call(api_url, payload, token);
}


/*
Base Caller functions
*/
function axios_post_call(api_url,data,token){
    return new Promise(function(resolve,reject){
        axios.post(api_url, data, {headers: {Authorization: `Bearer ${token}`}}).then((res)=>{
            if(res.status == 200){
                resolve(res.data);
            }
            else{
                reject();
            }
        }).catch((e)=>{
            reject(api_url+e);
        })
    })
}

export default {
    fetch_report_data,
    fetch_report_locations,
    create_report_folder,
    get_reports,
    update_report,
    delete_report,
    move_reports,
    publish_report,
    add_component,
    edit_component,
    update_audience,
    delete_report_component,
    fetch_component_options,
    save_report_plan,
    calculate_omni_channel
}
